<template lang="pug">
  section(id="trust")
     .goscontainer
        v-container
          .heading Как это работает?
          v-row
            v-col(cols="auto")
                img.mr-4(:src="require('@/assets/img/home/eagle.png')" width="199")
            v-col
                p Платформа модернизирует часть привычных процессов судопроизводства с учетом возрастающей нагрузки на суды и предоставляет специалистам ряд уникальных сервисов, объединенных в рамках единого программного комплекса.
                p Работает на основе данных Государственной автоматизированной системы "Правосудие"

            
</template>

<script>
  export default {
    name: 'SectionTrust',
  }
</script>

<style lang="sass" scoped>
  #trust
    padding: 24px 16px 
    color: #FFFFFF
    font-family: $slab
    font-weight: 300
    .heading 
        font-size: 32px
        margin-bottom: 32px
        color:#FFFFFF
    p
        margin-top:40px
        font-weight: 400
        font-size: 20px
        line-height: 32px
</style>
